import { FC, useState } from "react"
import { Plus } from "lucide-react"
import {
  useFindConnectorDetailsQuery,
  useFindConnectorsQuery
} from "../../../../redux/queries"
import { Brand } from "../../../../types"
import { useBrandSearchParam } from "../../../hooks"
import PrimaryBtn from "../../buttons/primary-btn"
import ConfigListShell from "../config-list-shell"
import ConnectorsTable from "./table"
import ManageConnector from "./manage"

interface Props {
  brands: Brand[]
}

const ConfigConnectors: FC<Props> = ({ brands }) => {
  const [selectedBrandId, setSelectedBrandId] = useBrandSearchParam()
  const [selectedConnectorId, setSelectedConnectorId] = useState<string>("")
  const [isCreating, setIsCreating] = useState<boolean>(false)

  const { data: connectors, isFetching } = useFindConnectorsQuery(
    { brand_id: selectedBrandId, active: undefined },
    { skip: !selectedBrandId }
  )

  const { data: connectorDetails } = useFindConnectorDetailsQuery(
    { id: selectedConnectorId },
    { skip: !selectedConnectorId }
  )

  const handleCreateNew = () => {
    setSelectedConnectorId("")
    setIsCreating(true)
  }

  const handleClose = () => {
    setSelectedConnectorId("")
    setIsCreating(false)
  }

  return (
    <ConfigListShell
      brands={brands}
      selectedBrandId={selectedBrandId}
      onBrandChange={setSelectedBrandId}
      actions={
        selectedBrandId ? (
          <PrimaryBtn onClick={handleCreateNew} className="flex items-center">
            <Plus size={16} className="mr-1" />
            Add New Connector
          </PrimaryBtn>
        ) : null
      }
    >
      {selectedBrandId ? (
        <ConnectorsTable
          data={connectors ?? []}
          isFetching={isFetching}
          onSelect={setSelectedConnectorId}
        />
      ) : null}

      <ManageConnector
        key={isCreating ? "create" : selectedConnectorId}
        open={!!selectedConnectorId || isCreating}
        data={isCreating ? undefined : connectorDetails}
        brandId={selectedBrandId}
        onClose={handleClose}
      />
    </ConfigListShell>
  )
}

export default ConfigConnectors
